import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 4px;
`

export const TextInputContainer = styled.div<{ fullWidth?: boolean; error?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;

  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};

  border: 1px solid ${({ error }) => (error ? 'var(--border-critical, #CB101D)' : 'var(--border-neutral, #bbc1d3)')};
  background: var(--background-elevation-base, #fff);
  border-radius: 6px;
  padding: 8px;
  box-sizing: border-box;
  height: 36px;

  /* var(--Background-Neutral-faded, #f3f4f6) */

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    padding: 12px 16px;

    height: 48px;
  }
`

export const Placeholder = styled.div<{ hasValue: boolean }>`
  color: ${({ hasValue }) =>
    hasValue ? 'var(--foreground-neutral, #14171f)' : 'var(--foreground-neutral-faded, #4d5874)'};

  opacity: ${({ hasValue }) => (hasValue ? 1 : 0.5)};

  line-height: 20px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    font-size: 16px;
  }
`

export const FakeInput = styled.input`
  opacity: 0;
  position: absolute;
  height: 0px;
  width: 0px;
  padding-top: 16px;

  color: var(--Foreground-Neutral, red);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  // change font of input value
`

export const ExpandContainer = styled.div<{ disabled?: boolean }>`
  display: ${({ disabled }) => (disabled ? 'none' : 'flex')};
  flex-direction: row;
  align-items: center;
`

export const Label = styled.label`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  color: var(--foreground-neutral, #14171f);
`

export const LabelOptional = styled.label`
  color: var(--foreground-neutral-faded, var(--foreground-neutral-faded, #4d5874));

  /* Body 3/Regular */
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`
